import { useNavigate } from 'react-router-dom';

import useProtectAction from '@/hooks/useProtectAction';
import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';
import { hasRenderableRating } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

import './styles/CommunityNotRatedCard.css';

export default function CommunityNotRatedCard({ data, ratingUser }) {
  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  const revealRatingEntry = {
    _id: data?._id ?? null,
    createdAt: data?.createdAt ?? null,
    rating_values: data?.rating_values ?? null,
    rating_creator: ratingUser ?? data?.rating_creator ?? null,
  };
  if (!hasRenderableRating(data)) {
    return null;
  }
  const isFollowing = resolveFollowState({ cacheHandler, userId: ratingUser?._id, imFollowing: ratingUser?.im_following });

  return (
    <>
      <div className="community-not-rated-card__outter-container">
        <div
          className={`community-not-rated-card__container ${isFollowing ? 'following' : ''}`}
          onClick={() =>
            navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
              state: {
                from: true,
                artworkViewSource: {
                  type: 'community',
                  label: '',
                },
                revealRatingEntry,
              }
            })
          }
        >
          <CardHeader
            image={ratingUser.user_image?.image_id}
            profileType={ratingUser.user_type}
            username={ratingUser.user_username}
            onUserClick={() => navigate(`/user/${ratingUser.user_username}`)}
            timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
            subtitle={
              <>
                on <span className="community-not-rated-card__artwork-title">{data.rating_artwork.artwork_about.artwork_title}</span>
              </>
            }
          />

          <ArtworkImage
            image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
            imageClassName="community-rating-card__artwork-image"
            imageTemplateClassName="community-rating-card__artwork-image"
            // forceSmaller={300}
          />

          <div className="community-not-rated-card__rate-section">
            <Text className="community-not-rated-card__text font-size-small" paragraph>
              Rate the artwork to see the results
            </Text>

            <Text
              className="community-not-rated-card__rate-button font-size-small"
              onClick={(e) => {
                e.stopPropagation();
                privateActionHandler(() =>
                  navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
                    state: {
                      from: true,
                      artworkViewSource: {
                        type: 'community',
                        label: '',
                      },
                      revealRatingEntry,
                    }
                  })
                );
              }}>
              Rate
            </Text>
          </div>
        </div>
      </div>
    </>
  );
}
